import { render } from "./MotheringClass.vue?vue&type=template&id=f2621c30"
import script from "./MotheringClass.vue?vue&type=script&lang=js"
export * from "./MotheringClass.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jack/Developer/Inncom/LCY/2110.lcy.app.vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__